module.exports = __webpack_public_path__ + "static/img/home22.448bdf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home22.png
// module id = /AKo
// module chunks = 13